import { FormControl, Select, Typography, MenuItem } from '@mui/material';
import { theme } from 'config';
import { t } from 'i18next';
import React from 'react';
import { ShowContentTypes } from 'types/filter';


export interface IContentFilterProps {
  value?: ShowContentTypes,
  onChange?(value: ShowContentTypes): void,
}

export const ContentFilter = (props: IContentFilterProps): JSX.Element => {
  const { value, onChange } = props;
  return (
    <FormControl fullWidth>
      <Select
        value        = {value || ShowContentTypes.All}
        onChange     = {(e) => onChange && onChange(e.target.value as ShowContentTypes)}
        renderValue  = {(value: ShowContentTypes) => (
          <Typography
            fontWeight={theme.typography.fontWeightBold}
          >
            {t('show')}:
            <Typography
              sx         = {{ ml: theme.spacing(1) }}
              component  = 'span'
              fontWeight = {theme.typography.fontWeightRegular}
            >
              {t(value)}
            </Typography>
          </Typography>
        )}
      >
        {Object.values(ShowContentTypes).map((o) => (
          <MenuItem key={o} value={o}>
            {' '}
            {t(o)}{' '}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};